import { HTTP_INTERCEPTORS } from "@angular/common/http"
import { LoaderInterceptorService } from './loader-interceptor.service'
import { ErrorInterceptorService } from './error-interceptor.service'
import { TokenInterceptorService } from './token-interceptor.service';

export const HttpInterceptProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true }
]
